import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignLeft,
  faAlignJustify,
  faUser,
  faTh,
  faPlus,
  faGrinAlt,
  faSignOutAlt,
  faCloudDownloadAlt,
  faFile,
  faDatabase,
  faCog,
  faUserEdit,
  faMinus,
  faQuestion,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/js/dist/collapse";
import { Switch, Route, Redirect } from "react-router-dom";
import api from "../config.json";
import auth from "../httpServices/authService";
import Loading from "../utill/LoadingComponent";
import { ToastContainer, toast } from "react-toastify";
import logo from "../assets/vg.png";
import MainReport from "../Reporting/MainReport";
import { generateExcelFile } from "../utill/download";
import InspectionType from "../Setting/InspectionType/InspectionType";
import InspectionTypeTable from "../Setting/InspectionType/InspectionTypeTable";
import PartMasterTest from "../Setting/PartMaster/PartMasterTest";
import PartMasterTable from "../Setting/PartMaster/PartMasterTable";
import MethodTable from "../Setting/method/methodTable";
import Method from "../Setting/method/method";
import QMSReport from "../Reporting/QMSReport";
import axios from "../httpServices/httpService";
import Inspection from "../DataEntry/IncomingInspec";
import MasterTemplate from "./MasterTemplate";
import joi from "joi";
import CheckSheetMaster from "../Setting/ChecksheetMaster/checkSheetmaster";
import ListTable from "../Setting/List/ListTable";
import ListForm from "../Setting/List/ListForm";
import CustomField from "../Setting/CustomFields/CustomFiield";
import CustomFieldList from "../Setting/CustomFields/CustomFieldList";
import ConfigReport from "../Setting/Reports/ConfigReports";
import Reports from "../Setting/Reports/ConfigReportList";
import ConfigReportList from "../Setting/Reports/ConfigReportList";
import ItemForm from "../Setting/ItemMaster/ItemForm";
import ItemList from "../Setting/ItemMaster/ItemList";
import QMSReportApproval from "../Reporting/ReportApproval";
import swal from "sweetalert";
import CustomInspectionMaster from "../Setting/CustomInspection/CustomInspectionForm";
import CustomInspectionList from "../Setting/CustomInspection/CustomInspectionList";
import InstrumentForm from "../Setting/Instrument/InstrumentForm";
import InstrumentList from "../Setting/Instrument/InstrumentList";
import User from "../Setting/User/User";
import UserTable from "../Setting/User/UserTable";
import UserGroup from "../Setting/UserGroup/UserGroup";
import UserGroupTable from "../Setting/UserGroup/UserGroupTable";

import UserRights from "../Setting/UserRights/UserRight";
import UserRightTable from "../Setting/UserRights/UserRightTable";
import CheckpointConfig from "../Setting/CheckpointConfig/CheckpointConfig";
import CheckpointConfigList from "../Setting/CheckpointConfig/CheckpointConfigList";
import UserRoleTable from "../Setting/UserRole/UserRoleTable";
import UserRole from "../Setting/UserRole/UserRole";
import MultipleImageUpload from "../Setting/ImageUploadMaster/ImageUploadMaster";
import ChangePassword from "./ChangePasswordForm";
import QRCodeList from "../Setting/QRCodeMaster/QRCodeList";
import QRCodeInspection from "../DataEntry/QRCodeInspection";
import ShiftSettingList from "../Setting/ShiftSettingMaster/ShiftSettingList";
import ShiftsettingForm from "../Setting/ShiftSettingMaster/ShiftsettingForm";
import AlertReport from "../Reporting/AlertReport";
import AlertList from "../Setting/AlertMaster/AlertList";
import AlertForm from "../Setting/AlertMaster/AlertForm";
import InspectionReminder from "../Setting/AlertMaster/InspectionReminderSetting";
import AlertRemarks from "../DataEntry/AlertRemarks";
import Storagemaster from "../Setting/StorageMaster/Storagemaster";
import EditInspection from "../DataEntry/EditInspection";
import OverviewDashboard from "../Dashbaord/OverviewDashboard";
import PDFDownloader from "../utill/PDFDownloader";
import SPCReport from "../Reporting/SPCReport";
import QualityDashboard from "../Dashbaord/QualityDashboard";

const InspectionArray = [
  {
    RightName: "IncomingInspection",
    ReportRoute: "/DataEntry/IncomingInspec",
    DisplayTitle: "Incoming Inspection",
    ChecksheetType: "Incoming Inspection",
    TableApi: "IncomingInspections",
    ButtonRedirect: "/report1",
  },
  {
    RightName: "FirstPartInspection",
    ReportRoute: "/DataEntry/FirstpartInspec",
    DisplayTitle: "First Part Inspection",
    ChecksheetType: "First Part Inspection",
    TableApi: "IncomingInspections",
    ButtonRedirect: "/report1",
  },
  {
    RightName: "InprocessTnspection",
    ReportRoute: "/DataEntry/InprocessInspec",
    DisplayTitle: "Inprocess  Inspection",
    ChecksheetType: "Inprocess Inspection",
    TableApi: "IncomingInspections",
    ButtonRedirect: "/report1",
  },
  {
    RightName: "LastPartInspection",
    ReportRoute: "/DataEntry/LastpartInspec",
    DisplayTitle: "Last Part Inspection",
    ChecksheetType: "Last Part Inspection",
    TableApi: "IncomingInspections",
    ButtonRedirect: "/report1",
  },
];
const Routes = [
  {
    RightName: "CustomerMaster",
    path: "/setting/customer",
    FieldName: "Customer",
    modalSize: "modal-xl",
    ApiName: "customer",
    MasterHeading: "Customer Master",
    schema: {
      Customer: joi.string().required().label("customer"),
    },
  },
  {
    RightName: "InstrumentType",

    path: "/setting/InstrumentType",
    FieldName: "InstrumentType",
    modalSize: "modal-xl",
    ApiName: "instrumentType",
    MasterHeading: "Instrument Type",
    schema: {
      InstrumentType: joi.string().required().label("Instrument Type"),
    },
  },

  // {
  //   RightName: "MeasurementUnit",
  //   path: "/setting/UOM",
  //   FieldName: "UOM",
  //   modalSize: "modal-xl",
  //   ApiName: "UOM",
  //   MasterHeading: "Unit Of Measurment",
  //   schema: {
  //     UOM: joi.string().required().label("UOM"),
  //   },
  // },
  // {
  //   path: '/setting/method',
  //   FieldName: "method",
  //   modalSize:"modal-xl",method
  //   ApiName: "method",
  //   MasterHeading: "Method",
  //   schema:{
  //     method:joi.string().required().label('method')
  //   }

  // },

];

class NavBarUser extends Component {

  state = {
    sidebar: true,
    company: null,
    querySuccess: false,
    userRights: null,
    inspectionArr: [],
    Heading: "",
    chnagePasswordModelState: false,
    chnagePasswordUserData: null,
  };

  componentDidMount() {
    this.GetAllInspetcionTypes();
    axios
      .get(api.api + "company/" + auth.getCurrentUser().company)
      .then((result) => {
        if (result.data) {
          this.setState({ company: result.data, querySuccess: true });
        } else {
          this.setState({ querySuccess: false });
        }
        this.setState({ querySuccess: false });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ querySuccess: false });
        // Uncomment and configure the toast notification if needed
        // toast.error(`${err.message}`, {
        //   position: 'bottom-right',
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   style: {
        //     background: 'red', // Set your desired background color
        //     color: 'white',    // Set your desired text color
        //   },
        // });
      });
    this.setState({ querySuccess: true });
    const user = auth.getCurrentUser();
    axios
      .put(api.api + "userrights", { email: user._id })
      .then((result) => {
        if (result.data) {
          this.setState({ userRights: result.data, querySuccess: false });
        } else {
          this.setState({ querySuccess: false });
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        swal(`${err}`);
      });
  }

  handleDownloadTableToExcel = (tableId) => {
    generateExcelFile(tableId, new Date(Date.now()));
  };
  handleToggleClick = () => this.setState({ sidebar: !this.state.sidebar });

  handleUserRightsToVisibleOrNot = (dataMemebre, data, perType) => {
    const rights = this.state.userRights;
    let allow = false;
    if (rights != null) {
      rights[dataMemebre].map((one) => {
        if (one.data == data) {
          allow = one[perType];
        }
      });
    }
    return allow;
  };

  GetAllInspetcionTypes = () => {
    axios
      .get(api.api + "customInspection")
      .then((result) => {
        const inspections = [...InspectionArray];
        result.data.forEach((one) => {
          const obj = {
            RightName: one.InspectionType,
            ReportRoute: `/DataEntry/${one.InspectionType}`,
            DisplayTitle: one.InspectionType,
            ChecksheetType: one.InspectionType,
            TableApi: "IncomingInspections",
            ButtonRedirect: "/report1",
            config: one,
          };
          inspections.push(obj);
        });
        this.setState({ inspectionArr: inspections });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handelSetHeading = (heading) => {
    console.log(heading, "heading from the report");
    this.setState({ Heading: heading });
  };

  handleCloseChnagePassword = () => {
    this.setState({ chnagePasswordModelState: false })
  }

  handleUserChangePassword = () => {
    this.setState({ chnagePasswordModelState: true, chnagePasswordUserData: auth.getCurrentUser() })
  }

  render() {
    const user = auth.getCurrentUser();
    const { handleUserRightsToVisibleOrNot, handelSetHeading } = this;
    if (!(handleUserRightsToVisibleOrNot && handelSetHeading)) {
      return <>Loading Please Wait....</>
    }

    return (
      <>
        <div className="wrapper">
          {this.state.querySuccess ? <Loading /> : ""}
          <ChangePassword handleClose={this.handleCloseChnagePassword} modelState={this.state.chnagePasswordModelState} user={this.state.chnagePasswordUserData} />
          <ToastContainer />
          <nav id="sidebar" className={this.state.sidebar ? "" : "active"}>
            <div className="sidebar-header text-center">
              <img
                src={this.state.company && this.state.company.logo}
                className="avatar"
                style={{
                  borderRadius: 2,
                  width: 150,
                  backgroundColor: "white",
                }}
              />
              <h4 className="text-white fw-bold">
                {""}
                <br />
                <label className="small">
                  {new Object(user).hasOwnProperty("company")
                    ? user.company.toUpperCase()
                    : ""}
                </label>
              </h4>
            </div>
            <ul className="list-unstyled components" id="parent">
              <p style={{ paddingTop: 0, paddingBottom: 0 }}>
                <FontAwesomeIcon icon={faUser} />
                &nbsp;&nbsp;{user ? user.name : ""}
                <br />
                &nbsp;&nbsp;
                <label className="small">{user ? user.userType : ""}</label>
              </p>
              <p style={{ fontSize: 15 }}><a className='btn btn-sm btn-primary' onClick={() => this.handleUserChangePassword()}>Change Password</a><br></br><a onClick={() => { auth.logout(user.email); window.location = '/' }} className='btn btn-sm btn-primary mt-1'>Logout&nbsp;<FontAwesomeIcon icon={faSignOutAlt} /></a></p>
              <li className="active">
                <a
                  href="#dashboard"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Dashboard
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="dashboard"
                  data-parent="#parent"
                >

                  <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/");
                      }}
                    >
                      Overview Dashboard
                    </a>
                  </li>
                  {/* <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/quality_dashboard");
                      }}
                    >
                      Quality Dashboard
                    </a>
                  </li> */}



                </ul>
              </li>
              <li className="active">
                <a
                  href="#live"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Reports
                </a>

                <ul
                  className="collapse list-unstyled"
                  id="live"
                  data-parent="#parent"
                >
                  <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/qms_report");
                      }}
                    >
                      View Report
                    </a>
                  </li>

                  <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/view_spc_report");
                      }}
                    >
                      SPC Report
                    </a>
                  </li>

                  <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/alert_report");
                      }}
                    >
                      View Alerts
                    </a>
                  </li>


                  {/* <li>
                  <a className="text-white" href="#" style={{ cursor: 'pointer' }} onClick={() => { this.props.history.push('/report1') }}>Create Report</a>
                </li> */}
                </ul>
              </li>

              <li className="active">
                <a
                  href="#dataentry"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Data Entry
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="dataentry"
                  data-parent="#parent"
                >
                  {/* {this.state.inspectionArr.map(
                    (item) =>
                      handleUserRightsToVisibleOrNot(
                        "DynamicDataRights",
                        item.RightName,
                        "write"
                      ) && (
                        <li>
                          <a
                            className="text-white"
                            href="#"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.props.history.push(item.ReportRoute);
                            }}
                          >
                            {item.DisplayTitle}
                          </a>
                        </li>
                      )
                  )} */}

                  {handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Manual Inspection",
                    "read"
                  ) && <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/enter_report");
                        }}
                      >
                        Enter New Report
                      </a>
                    </li>}
                  {handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "QRCode Inspection",
                    "write"
                  ) && <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/enter_report_qr");
                        }}
                      >
                        Scan QR Code
                      </a>
                    </li>}
                  {handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "EditReport",
                    "read"
                  ) && <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/edit_report");
                        }}
                      >
                        Edit Report
                      </a>
                    </li>}
                  {handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "AlertRemarks",
                    "read"
                  ) && <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/alert_remarks");
                        }}
                      >
                        Enter Alert Remarks
                      </a>
                    </li>}
                </ul>
              </li>
              <li className="active">
                <a
                  href="#approval"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Approval
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="approval"
                  data-parent="#parent"
                >
                  {handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "InspectionApproval",
                    "write"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/qms_report_approval");
                          }}
                        >
                          {"Approve Reports"}
                        </a>
                      </li>
                    )}
                </ul>
              </li>
              <li className="active">
                <a
                  href="#master"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Master
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="master"
                  data-parent="#parent"
                >
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InspectionMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/setting/custom_inspection/list"
                            );
                          }}
                        >
                          Inspection Master
                        </a>
                      </li>
                    )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "ConfigureCheckpoint",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/setting/checkpoint_config/list"
                            );
                          }}
                        >
                          Configure Checkpoint
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "CheckSheetMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/CheckSheetMaster");
                          }}
                        >
                          Check Sheet Master
                        </a>
                      </li>
                    )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "ListMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/content/list");
                          }}
                        >
                          List Master
                        </a>
                      </li>
                    )}



                  {/* {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "MethodMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/method/list");
                          }}
                        >
                          Methods
                        </a>
                      </li>
                    )} */}








                  {Routes.map(
                    (route) =>
                      handleUserRightsToVisibleOrNot(
                        "StaticDataRights",
                        route.RightName,
                        "read"
                      ) && (
                        <li key={route.id}>
                          <a
                            className="text-white"
                            href="#"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.props.history.push(route.path);
                            }}
                          >
                            {route.MasterHeading}
                          </a>
                        </li>
                      )
                  )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/instrument/list");
                          }}
                        >
                          Instrument Master
                        </a>
                      </li>
                    )}
                  {/* <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/rulemaster/form");
                          }}
                        >Rule Master
                        </a>
                      </li> */}
                  <li>
                    <a
                      className="text-white"
                      href="#"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push("/setting/rulemaster/list");
                      }}
                    >Time Rule Master
                    </a>
                  </li>

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "ItemMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/item/list");
                          }}
                        >
                          Item Master
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/image_upload_master/list");
                          }}
                        >
                          Check Sheet Image Master
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/alert/list");
                          }}
                        >
                          Alert Recipient Master
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/reminder");
                          }}
                        >
                          Inspection Reminder
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/qr_code/list");
                          }}
                        >
                          Item Inspection QR
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "InstrumentMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/setting/Storagemaster");
                          }}
                        >
                          Manage Storage
                        </a>
                      </li>
                    )}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "UserMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          href="#user"
                          data-toggle="collapse"
                          aria-expanded="false"
                          aria-controls="user"
                          className="collapsed dropdown-toggle text-white"
                        >
                          User Master
                        </a>
                        <ul
                          className="collapse list-unstyled"
                          id="user"
                          data-parent="#master"
                        >
                          <li data-parent="#user">
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.props.history.push(
                                  "/setting/userrole/list"
                                );
                                this.setState({
                                  navSelected: "/setting/userrole/list",
                                  cardDashboardState: false,
                                  andonDashboardState: false,
                                  macStateDashboardState: false,
                                  activityDashboardState: false,
                                });
                              }}
                            >
                              User Role Master
                            </a>
                          </li>
                          <li data-parent="#user">
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.props.history.push(
                                  "/setting/usergroup/list"
                                );
                                this.setState({
                                  navSelected: "/setting/usergroup/list",
                                  cardDashboardState: false,
                                  andonDashboardState: false,
                                  macStateDashboardState: false,
                                  activityDashboardState: false,
                                });
                              }}
                            >
                              User Group Master
                            </a>
                          </li>
                          <li>
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.props.history.push(
                                  "/setting/userrights/list"
                                );
                                this.setState({
                                  navSelected: "/setting/userrights/list",
                                  cardDashboardState: false,
                                  andonDashboardState: false,
                                  macStateDashboardState: false,
                                  activityDashboardState: false,
                                });
                              }}
                            >
                              User Rights Master
                            </a>
                          </li>
                          <li>
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.props.history.push("/setting/user/list");
                                this.setState({
                                  navSelected: "/setting/user/list",
                                  cardDashboardState: false,
                                  andonDashboardState: false,
                                  macStateDashboardState: false,
                                  activityDashboardState: false,
                                });
                              }}
                            >
                              User Master
                            </a>
                          </li>
                        </ul>
                      </li>
                    )}
                </ul>
              </li>
            </ul>
            <div className="mt-5 text-center">
              <p className="small mb-0">
                Version:{api.UIVersion}/{this.state.version}
              </p>
              <p className="small mb-0">&copy; Copyright 2021 Leafnet</p>
              <p className="small">
                Powered By{" "}
                <a
                  title="Driti Tech."
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://drititech.com/"
                >
                  : Driti Technologies LLP.
                </a>
              </p>
            </div>
          </nav>
          <div id="content" style={{ padding: 0 }}>
            <div className="">
              <nav
                className="d-flex w-100 navbar navbar-expand-lg m-0 py-0"
                style={{ padding: 0 }}
              >
                <div
                  style={{ width: "10%" }}
                  className=" d-flex justify-content-between"
                >
                  <div className="">
                    <input
                      id="checkbox"
                      type="checkbox"
                      onClick={this.handleToggleClick}
                    />
                    <label className="toggle btn-info m-0" htmlFor="checkbox">
                      <div id="bar1" className="bars"></div>
                      <div id="bar2" className="bars"></div>
                      <div id="bar3" className="bars"></div>
                    </label>
                  </div>
                </div>
                <div style={{ width: "80%" }} className="">
                  <div className="text-start text-center text-black  fs-4 fw-medium text-wrap">
                    {this.state.Heading}
                  </div>
                </div>
              </nav>
            </div>
            <main className="mx-2">
              <Switch>
                <Route path="/quality_dashboard" exact render={(props) => <QualityDashboard {...props} Heading={this.handelSetHeading} />} />
                <Route path="/" exact render={(props) => <OverviewDashboard {...props} />} />
                <Route
                  path="/qms_report"
                  exact
                  render={(props) => <QMSReport {...props}
                    Heading={this.handelSetHeading}
                    companyName={this.state.company && this.state.company.name}
                  />}
                />
                <Route
                  path="/view_spc_report"
                  exact
                  render={(props) => <SPCReport {...props}
                    Heading={this.handelSetHeading}
                  />}
                />
                <Route
                  path="/alert_report"
                  exact
                  render={(props) => <AlertReport {...props}
                    Heading={this.handelSetHeading}
                  />}
                />
                <Route
                  path="/qms_report_approval"
                  exact
                  render={(props) => (
                    <QMSReportApproval
                      {...props}
                      Heading={this.handelSetHeading}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}


                    />
                  )}
                />
                <Route
                  path="/report1"
                  exact
                  render={(props) => (
                    <MainReport
                      {...props}
                      handleDownloadTableToExcel={
                        this.handleDownloadTableToExcel
                      }
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/inspectionType/list"
                  exact
                  render={(props) => (
                    <InspectionTypeTable
                      {...props}
                      RightName="InspectionTypeMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/inspectionType/add"
                  exact
                  render={(props) => (
                    <InspectionType
                      {...props}
                      RightName="InspectionTypeMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/method/list"
                  exact
                  render={(props) => (
                    <MethodTable
                      {...props}
                      RightName="MethodMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/method/add"
                  exact
                  render={(props) => (
                    <Method
                      {...props}
                      RightName="MethodMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/partMaster/add"
                  render={(props) => (
                    <PartMasterTest
                      {...props}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/partMaster/list"
                  render={(props) => (
                    <PartMasterTable
                      {...props}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/CheckSheetMaster"
                  render={(props) => (
                    <CheckSheetMaster
                      {...props}
                      RightName="CheckSheetMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/content/list"
                  render={(props) => (
                    <ListTable
                      {...props}
                      RightName="ListMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/list/form"
                  render={(props) => (
                    <ListForm
                      {...props}
                      RightName="ListMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/customfield/list"
                  render={(props) => (
                    <CustomFieldList
                      {...props}
                      RightName="CustomFieldMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/customfield/form"
                  render={(props) => (
                    <CustomField
                      {...props}
                      RightName="CustomFieldMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/configreport/form"
                  render={(props) => (
                    <ConfigReport
                      {...props}
                      RightName="ConfigReportMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/configreport/list"
                  render={(props) => (
                    <ConfigReportList
                      {...props}
                      RightName="ConfigReportMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/item/form"
                  render={(props) => (
                    <ItemForm
                      {...props}
                      RightName="ItemMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/item/list"
                  render={(props) => (
                    <ItemList
                      {...props}
                      RightName="ItemMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/checkpoint_config/form"
                  render={(props) => (
                    <CheckpointConfig
                      {...props}
                      RightName="ConfigureCheckpoint"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/checkpoint_config/list"
                  render={(props) => (
                    <CheckpointConfigList
                      {...props}
                      RightName="ConfigureCheckpoint"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/custom_inspection/form"
                  render={(props) => (
                    <CustomInspectionMaster
                      {...props}
                      RightName="InspectionMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/custom_inspection/list"
                  render={(props) => (
                    <CustomInspectionList
                      {...props}
                      RightName="InspectionMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/instrument/form"
                  render={(props) => (
                    <InstrumentForm
                      {...props}
                      RightName="InstrumentMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/alert/list"
                  render={(props) => (
                    <AlertList
                      {...props}
                      RightName="InstrumentMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/setting/reminder"
                  render={(props) => (
                    <InspectionReminder
                      {...props}
                      RightName="InstrumentMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/setting/alert/form"
                  render={(props) => (
                    <AlertForm
                      {...props}
                      RightName="InstrumentMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}

                    />
                  )}
                />
                <Route
                  path="/setting/instrument/list"
                  render={(props) => (
                    <InstrumentList
                      {...props}
                      RightName="InstrumentMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/user/add"
                  render={(props) => (
                    <User
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                <Route
                  path="/setting/user/list"
                  render={(props) => (
                    <UserTable
                      {...props}
                      user={user}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/usergroup/add"
                  render={(props) => (
                    <UserGroup
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/userrole/list"
                  render={(props) => (
                    <UserRoleTable
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/userrole/add"
                  render={(props) => (
                    <UserRole
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/usergroup/list"
                  render={(props) => (
                    <UserGroupTable
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/image_upload_master/list"
                  render={(props) => (
                    <MultipleImageUpload
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/setting/qr_code/list"
                  render={(props) => (
                    <QRCodeList
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                {/* <Route path='/setting/userrights/add' render={props => <UserRights {...props}  userRights={this.state.userRights} getRightsForAccess={handleUserRightsToVisibleOrNot}
                        Heading={this.handelSetHeading}
                 user={user} userRightsData={this.state.userRights} />} /> */}
                <Route
                  path="/setting/userrights/list"
                  render={(props) => (
                    <UserRightTable
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />

                <Route
                  path="/dataentry/alert_remarks"
                  render={(props) => (
                    <AlertRemarks
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                {/* {this.state.inspectionArr.map((item) => (
                  <Route
                    path={item.ReportRoute}
                    render={(props) => (
                      <Inspection
                        {...props}
                        config={item.config || {}}
                        RightName={item.RightName}
                        getRightsForAccess={handleUserRightsToVisibleOrNot}
                        Heading={this.handelSetHeading}
                        DisplayTitle={item.DisplayTitle}
                        TableApi={item.TableApi}
                        ButtonRedirect={item.ButtonRedirect}
                        ChecksheetType={item.ChecksheetType}
                      />
                    )}
                  />
                ))} */}
                <Route
                  path="/dataentry/enter_report"
                  render={(props) => (
                    <Inspection
                      {...props}
                      Inspections={this.state.inspectionArr}
                      // config={item.config || {}}
                      RightName="DynamicDataRights"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      //DisplayTitle={item.DisplayTitle}
                      // TableApi={item.TableApi}
                      userRights={this.state.userRights}
                      ButtonRedirect={"/report1"}
                    // ChecksheetType={item.ChecksheetType}
                    />
                  )}
                />
                <Route
                  path="/dataentry/enter_report_qr"
                  render={(props) => (
                    <QRCodeInspection
                      {...props}
                      Inspections={this.state.inspectionArr}
                      // config={item.config || {}}
                      RightName="DynamicDataRights"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      //DisplayTitle={item.DisplayTitle}
                      // TableApi={item.TableApi}
                      userRights={this.state.userRights}
                      ButtonRedirect={"/report1"}
                    // ChecksheetType={item.ChecksheetType}
                    />
                  )}
                />
                <Route
                  path="/dataentry/edit_report"
                  render={(props) => (
                    <EditInspection
                      {...props}
                      Inspections={this.state.inspectionArr}
                      // config={item.config || {}}
                      RightName="DynamicDataRights"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      //DisplayTitle={item.DisplayTitle}
                      // TableApi={item.TableApi}
                      userRights={this.state.userRights}
                      ButtonRedirect={"/report1"}
                    // ChecksheetType={item.ChecksheetType}
                    />
                  )}
                />
                {Routes.map((route) => (
                  <Route
                    path={route.path}
                    exact
                    render={(props) => (
                      <MasterTemplate
                        {...props}
                        RightName={route.RightName}
                        getRightsForAccess={handleUserRightsToVisibleOrNot}
                        FieldName={route.FieldName}
                        ApiName={route.ApiName}
                        MasterHeading={route.MasterHeading}
                        renderComp={route.renderComp}
                        modalSize={route.modalSize}
                        schema={route.schema}
                        Heading={this.handelSetHeading}
                      />
                    )}
                  />
                ))}
                <Route
                  path="/setting/rulemaster/form"

                  render={(props) => (
                    <ShiftsettingForm
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                <Route
                  path="/setting/rulemaster/list"
                  render={(props) => (
                    <ShiftSettingList
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                <Route
                  path="/setting/Storagemaster"
                  render={(props) => (
                    <Storagemaster
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                <Route
                  path="/setting/PDFDownloader"
                  render={(props) => (
                    <PDFDownloader
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />


              </Switch>
            </main>
          </div>
        </div>
      </>
    );
  }
}

export default NavBarUser;
